module.exports = __webpack_public_path__ + "img/chewy-oatmeal-raisin-cookies.c972371d.jpg";